import PropTypes from 'prop-types'

import PostSchema from './PostSchema'
import UserSchema from './UserSchema'

/*
EXAMPLE:

{
  "id": "1",
  "post": {},
  "sharer": {},
}

*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  post: PostSchema.isRequired,
  sharer: UserSchema,
})
